(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('MyProfileController', MyProfileController)

    /** @ngInject */
    function MyProfileController($q, HelperService, PersonService, MeService, AuthenticationService, NotifyService, sweetAlert) {
        const vm = this;

        vm.passwordValidator = AuthenticationService.passwordValidator;

        // Main image
        vm.flowFileAdded = $file => {
            let blacklist = ['png', 'gif', 'jpg', 'jpeg'];
            let extension = $file.getExtension();

            if (!blacklist.includes(extension)) {
                HelperService.setErrorMessageForm('.image-block', 'Formato inválido.', true);
                return false;
            }

            vm.oldFormImageMain = vm.mainImageData.Url;

            HelperService.startLoading('.image-loading-holder');

            HelperService.removeErrorMessageForm('.image-block');
        }

        vm.flowFileFinishedMain = ($file, $message) => {
            let message = angular.fromJson($message);

            vm.mainImageData.Url = message.FileSaveName;

            let imageData = {
                PersonId: vm.personData.Id,
                Main: true,
                Url: vm.mainImageData.Url,
                Description: ''
            }

            saveImage(imageData);
        }

        vm.deleteImage = imageData => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.image-loading-holder');

                    UnitService
                        .deleteImage(imageData.Id)
                        .then(() => {
                            if (!imageData.Main) {
                                var index = vm.unitGallery.indexOf(imageData);

                                if (index !== -1)
                                    vm.unitGallery.splice(index, 1);
                            } else {
                                vm.mainImageData = {
                                    Url: '',
                                    Display: ''
                                }

                                if (vm.flowScopeMain.flow.files.length)
                                    vm.flowScopeMain.flow.files[0].cancel();
                            }

                            HelperService.stopLoading('.image-loading-holder');
                            HelperService.successCallback();
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.image-loading-holder');
                        })
                }
            })
        }

        vm.saveMyProfile = () => {
            HelperService.startLoading('.loading-holder');

            let personData = {
                Name: vm.personData.Name,
                GenderId: vm.personData.GenderId,
                Birthdate: HelperService.getMomentDate(vm.personData.BirthdateFormatted).format('YYYY-MM-DD')
            }

            let personDocuments = vm.personData.Person_Document.reduce((acc, cur) => {
                acc.push({
                    DocumentTypeId: cur.DocumentTypeId,
                    Document: cur.Document
                })

                return acc;
            }, []);

            if (!personDocuments.find(x => x.DocumentTypeId == 1)) {
                sweetAlert.swal({
                    title: 'Aviso',
                    text: 'Você também deve informar o seu CPF no cadastro!',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })

                HelperService.stopLoading('.loading-holder');
                return;
            }

            let personEmails = vm.personData.Person_Email.reduce((acc, cur) => {
                acc.push({
                    EmailTypeId: cur.EmailTypeId,
                    Email: {
                        Address: cur.Email.Address
                    }
                })

                return acc;
            }, []);

            let personTelephones = vm.personData.Person_Phone.reduce((acc, cur) => {
                acc.push({
                    PhoneTypeId: cur.PhoneTypeId,
                    Phone: {
                        Code: cur.Phone.Code,
                        Number: cur.Phone.Number
                    }
                })

                return acc;
            }, []);

            personData.Person_Document = personDocuments;
            personData.Person_Email = personEmails;
            personData.Person_Phone = personTelephones;

            MeService
                .updateMe(personData)
                .then(() => {
                    HelperService.successCallback();
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.saveMyPassword = () => {
            HelperService.startLoading('.loading-holder');

            let personPasswordData = {
                NewPassword: Encrypt.Hash(vm.changePasswordData.NewPassword).toString(),
                OldPassword: Encrypt.Hash(vm.changePasswordData.OldPassword).toString()
            }

            MeService
                .updateMePassword(personPasswordData)
                .then(() => {
                    NotifyService.success('Senha alterada com sucesso');
                    HelperService.stopLoading('.loading-holder');

                    vm.cancelEditPassword();
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.editPassword = () => {
            vm.isEditingPersonData = false;
            vm.isEditingPasswordData = true;
        }

        vm.cancelEditPassword = () => {
            vm.isEditingPersonData = true;
            vm.isEditingPasswordData = false;
            vm.changePasswordData = {};
        }

        init();

        function saveImage(imageData) {
            HelperService.startLoading('.image-loading-holder');

            MeService
                .saveImage(imageData)
                .then(() => {
                    vm.mainImageData.Display = HelperService.imageResizePath('person', vm.personData.Id, vm.mainImageData.Url, 150, 150);

                    HelperService.stopLoading('.image-loading-holder');
                    HelperService.successCallback();
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.image-loading-holder');
                })
        }

        function getGenders() {
            return PersonService
                .getGenders()
                .then(success => {
                    vm.genders = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getPerson() {
            const loggedPersonId = AuthenticationService.getSelectedData().PersonId;

            if (!loggedPersonId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os seus dados!',
                    text: 'Ocorreu um erro ao buscar o seu identificador',
                    type: 'warning',
                    confirmButtonText: 'Ir para Login',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.stopLoading('.loading-holder');

                        AuthenticationService.logout();
                    }
                })

                return;
            }

            PersonService
                .get(loggedPersonId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedRegistrationDate = '-';

                    if (success.Birthdate)
                        success.BirthdateFormatted = moment(success.Birthdate).format('DD/MM/YYYY');

                    vm.personData = success;

                    if (vm.personData.GenderId)
                        vm.selectedGender = vm.genders.find(gender => (gender.Id == vm.personData.GenderId));

                    if (vm.personData.Person_Image.length) {
                        let personMainImage = vm.personData.Person_Image.find(image => (image.Main));

                        if (personMainImage) {
                            vm.mainImageData.Url = personMainImage.Url;
                            vm.mainImageData.Display = HelperService.imageResizePath('person', vm.personData.Id, personMainImage.Url, 150, 150);
                        }
                    }

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            vm.selectedTab = 1;
            vm.isEditingPersonData = true;
            vm.isEditingPasswordData = false;
            vm.changePasswordData = {};

            vm.mainImageData = {
                Url: '',
                Display: ''
            }

            vm.flowOptionsMain = {
                query: () => {
                    return {
                        Path: `person/${vm.personData.Id}`,
                        OldImage: vm.oldFormImageMain,
                        CreateThumb: false,
                        CreateThumbAdmin: false
                    }
                }
            }

            angular.extend(vm.flowOptionsMain, HelperService.getFlowOptionsDefaults());
        }

        function init() {
            initVars();

            HelperService.startLoading('.loading-holder');

            $q.all([getGenders()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());